import { Dispatch } from 'redux';
import { Perpetrator, UpdateReport } from 'src/api';
import { updateReport } from 'src/creators/MCC.creators';
import { Evidence } from 'src/reducers/ManualCase';
import * as Types from '../../../../types';
import { mapMCCEventToEvidence } from './mapMCCEventToEvidence';

const removeEventEvidence = (evidence: Evidence[], eventID: string) =>
  evidence.filter((e) => e.event !== eventID);
const findEventEvidence = (evidence: Evidence[], eventID: string) =>
  evidence.filter((e) => e.event === eventID);

export const updateExistingEvent = async (
  currentReport: UpdateReport,
  reportID: string,
  event: Types.MCCEventType,
  eventID: string,
  dispatch: Dispatch,
) => {
  if (currentReport.evidence) {
    const timestamp = String(new Date(Date.now()));
    const { evidence } = currentReport;
    // Remove evidence of old event and replace with new
    const otherEvidence = removeEventEvidence(evidence.evidence, eventID);
    const thisEventEvidence = findEventEvidence(evidence.evidence, eventID);
    const newEventEvidence = mapMCCEventToEvidence(
      event,
      reportID,
      eventID,
      thisEventEvidence,
    ).evidence;
    const updatedEvidence = [...otherEvidence, ...newEventEvidence];

    // Get perpetrators from the updated evidence
    const updatedPerpetrators = updatedEvidence
      .filter((e) => e.type === '@evidence/perpetrator')
      .map((e) => e.value);
    await updateReport(reportID, {
      ...currentReport,
      evidence: {
        ...evidence,
        events: evidence.events.map((e) =>
          // Update event with new timestamp
          e.id === eventID ? { ...e, updated: timestamp } : e,
        ),
        evidence: updatedEvidence,
      },
      perpetrators: updatedPerpetrators as Perpetrator[],
    })(dispatch);
  }
};
